import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  correspondingClientData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'correspondingClient',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getCorrespondingClientInfo: (state, action) => {
      state.correspondingClientData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;
const {getCorrespondingClientInfo, fetchStart, fetchError} = slice.actions;

export const fetchCorrespondingClients = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/Correspondence/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCorrespondingClientInfo(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
